module.exports = __webpack_public_path__ + "img/jgl2.155191ba.jpg";